
// api/advertiser.js
import request from './request'

export const advertiserApi = {
    // 获取广告主列表
    getList(params) {
        return request({
            url: '/token/advertiser/get',
            method: 'get',
            withCredentials: false,
            params: {
                appId: "fff",
                secret: "ggg"
            }
        })
    }
}
